import { Play } from 'lucide-react'
import { FC } from 'react'

interface UnifiedPlayMarkProps {
  className?: string
}

/** 公開動画の入口・再生画面で共通利用する再生マーク。 */
const UnifiedPlayMark: FC<UnifiedPlayMarkProps> = ({ className = '' }) => (
  <span
    aria-hidden="true"
    className={`flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-full transition-transform duration-200 group-hover:scale-[1.2] ${className}`}
    style={{
      background: 'rgba(255,255,255,0.2)',
      border: '1px solid rgba(255,255,255,0.5)',
      backdropFilter: 'blur(1px)',
      WebkitBackdropFilter: 'blur(1px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    }}
  >
    <Play
      size={26}
      strokeWidth={2.25}
      color="rgba(255,255,255,0.9)"
      style={{ transform: 'translateX(2px)' }}
    />
  </span>
)

export default UnifiedPlayMark
